import React from 'react'

import NavbarHeader from '../../../Navbarheader/NavbarHeader';
import Footer from '../../../Footer/Footer';
import Herosection from './components/Herosection';

import './ola.css'
import Intro from './components/Intro';
import Bannerdisplay from './components/Bannerdisplay';

import Mockupone from './components/Mockupone';
import Mockuptwo from './components/Mockuptwo';
import Introtwo from './components/Introtwo';
import Pallete from './components/Pallete';

import NextProjectButton from "../components/NextProjectButton";
import { useNavigate } from 'react-router-dom';



function Olabranding() {
  const navigate = useNavigate();

  const handleNextProjectClick = () => {
    navigate('/project/edgemarketing');
  };

  return (
    <div fluid  className="scroll-container">
    <NavbarHeader />
     <Herosection />
     <Intro />
     <Introtwo />
     <Pallete />
     <Bannerdisplay />
     <Mockupone />
     <div id="showNextButton"><Mockuptwo /></div>
     
    

    
    
     
    <Footer />

    <NextProjectButton 
        sectionId="showNextButton" 
        onClick={handleNextProjectClick} 
      />
  </div>
  )
}

export default Olabranding;
